import React, { Component } from 'react';
import { func } from 'prop-types';

// Page styles
import s from './ForgotPasswordDialog.css';

/**
 * Article for Assumptions & Patterns:
 *  https://engineering.musefind.com/our-best-practices-for-writing-react-components-dec3eb5c3fc8
 *
 * setState() is asynchronous because react batches changes
 * for performance reasons. The state may not change immediately
 * after calling setState(), which means you should not rely on
 * the current state when calling setState, but rather pass a callback
 * function.
 */
export default class ForgotPasswordDialog extends Component {
  state = {
    value: undefined,
  };

  static propTypes = {
    closeConfirmDialog: func,
    openConfirmDialog: func,
    handleForgotPassword: func,
    hideFullPageLoadingState: func,
    showFullPageLoadingState: func,
  };

  /**
   * Handle the text field input by updating the state each time
   * the input changes.
   *
   * WARNING: The synthetic event is reused for performance reasons.
   * The property `target` could be released/nullified on a
   * synthetic event. Therefore, set it to a constant and release it.
   */
  handleChange = (event) => {
    const value = event.target.value;

    this.setState(prevState => ({ value }));
  };

  onClickHandler = () =>
    this.props.openConfirmDialog({
      title: 'Forgot Password',
      cancelCallback: () => {
        this.setState(prevState => ({ value: undefined }));
        this.props.closeConfirmDialog()
      },
      cancelLabel: 'Cancel',
      okCallback: this.submit,
      okLabel: 'Send',
      content:
        <div>
          <p className={s.helpText}>
            If you have forgotten your password, please enter the username associated with your account.
            If we can locate your account based on the username you enter and
            <strong> if the practice has a current email address for you</strong>,
            we will send a new password to your email address. Please note: for your protection, you will have to re-verify
            your account after you have received your new password.
          </p>
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="forgotPasswordDialogInput">
              Username
            </label>
            <input
              id="forgotPasswordDialogInput"
              name="username"
              type="text"
              onChange={this.handleChange}
              className={s.control}
              required
              value={this.state.value}
            />
          </div>
        </div>
    });

  /**
   * Forgot Password API call with no operation. Send the request
   * and carry on with your day.
   */
  submit = () => {
    const username = this.state.value;

    // Fail silently
    if (username === undefined) {
      this.props.closeConfirmDialog();
      return false;
    }

    // Success and error callbacks are the same - hideFullPageLoadingState
    const callback = () => {
      this.setState(prevState => ({ value: undefined }));
      this.props.hideFullPageLoadingState();
    };

    this.props.showFullPageLoadingState();

    this.props.handleForgotPassword(username, callback, callback);

    this.props.closeConfirmDialog();
  };

  render = () =>
    <a
      className={s.cta}
      onClick={this.onClickHandler}
      title="Forgot password?"
    >
      Forgot password?
    </a>;
}



// WEBPACK FOOTER //
// ./src/components/Pages/Login/ForgotPasswordDialog/ForgotPasswordDialog.js